import { useListTrainers } from "@/api/generated/enrollments/enrollments";
import { TrainerCardContent } from "@/components/dashboard/TrainerCardContent";

interface TrainerCardProps {
  enrollmentId: string;
}

export const TrainerCard = ({ enrollmentId }: TrainerCardProps) => {
  // A failed request hides the card, like an empty trainer list does.
  const { data, isLoading } = useListTrainers(enrollmentId);
  const trainers = data?.trainers ?? [];

  if (isLoading || trainers.length === 0) return null;

  return <TrainerCardContent trainers={trainers} />;
};
